import script from "./VoicePop.vue?vue&type=script&setup=true&lang=js"
export * from "./VoicePop.vue?vue&type=script&setup=true&lang=js"

import "./VoicePop.vue?vue&type=style&index=0&id=1fe44d30&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe44d30"]])

export default __exports__